import React, { Component } from 'react';
import { Button, Form, Input, message as Message } from 'antd';
import { bindMerchantAccount } from '../../api'
const FormItem = Form.Item;
class AccountBind extends Component {

    onSubmit = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                let { status, message } = await bindMerchantAccount(values)
                if (status === 200) {
                    Message.success('绑定成功')
                    this.props.onSubmited && this.props.onSubmited()
                } else {
                    Message.error(message)
                }
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form
        return <Form>
            <FormItem>
                {getFieldDecorator('userName', {
                    rules: [{ required: true, message: '请输入账号' }, { min: 4, message: '帐号长度在4-20之间' }, { max: 20, message: '帐号长度在4-20之间' }],
                })(
                    <Input maxLength={20} placeholder="请输入账号" />
                )}
            </FormItem>
            <FormItem>
                {getFieldDecorator('passWord', {
                    rules: [{ required: true, message: '请输入账号' }, { min: 4, message: '密码长度最少为4' }],
                })(
                    <Input type="password" placeholder="请输入密码" />
                )}
            </FormItem>
            <FormItem>
                {getFieldDecorator('passWord2', {
                    rules: [{
                        required: true, message: '请再次输入密码'
                    }, {
                        validator: (rule, value, callback) => {
                            const form = this.props.form;
                            if (value && value !== form.getFieldValue('passWord')) {
                                callback('两次密码必须输入一致');
                            } else {
                                callback();
                            }
                        },
                    }],
                })(
                    <Input type="password" placeholder="请再次输入密码" />
                )}
            </FormItem>
            <FormItem style={{ textAlign: 'center', marginBottom: 0 }}>
                <Button type="primary" onClick={this.onSubmit}>立即绑定</Button>
            </FormItem>
        </Form>
    }
}

export default Form.create()(AccountBind)


// WEBPACK FOOTER //
// ./src/components/AccountBind/index.jsx